
import { CustomAutocomplete, CustomTextField, FormTabsOnly, LoaderComponent, NestedTabsScene, SampleCheckbox, SampleDatePicker, SingleButton, TabTextLabel } from "@/shared/components/ui"
import { Grid, Tab, Typography } from "@mui/material"
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import FileDownloadDoneIcon from '@mui/icons-material/FileDownloadDone';
import useRegistroFacturas from "../../hook/useRegistroFacturas";
import { useCallback, useEffect, useRef, useState } from "react";
import { a11yProps, gridSize, gridSizeMdLg4, gridSizeMdLg6, ROUTER_PATHS } from "@/shared";

import { OrdenesCompra } from "@/shared/interfaces/erp/compras/ordenes-compra.interface";
import { BODEGAS } from "@/shared/interfaces/erp/inventario";
import { MaterialTransferido, PROVEEDOR, TipoComprobante } from "@/shared/interfaces";
import { CustomTabPanel } from "@/erp/sale";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { FormProvider } from "react-hook-form";

import RegistroFacturaGastos from "../sections/RegistroFacturaGastos";
import ValoresFactura from "../sections/ValoresFactura";
import { useGastos } from "@/store/erp/gastos/useGastos";
import RegistroFacturaOrdenCompra from "../sections/RegistroFacturaOrdenCompra";
//import CargarDocumentoSoluccionCosteada from "@/erp/venta-corporativa/solucion_costeada/shared/componente/cargar_documento_soluccion_costeada/CargarDocumentoSoluccionCosteada";
import { toast } from "react-toastify";
import XmlUploader from "../../hook/useXMLUpdoader";




type SaveRegistroFacturasProps = {
  titlePage: string
}
export default function SaveRegistroFacturas({ titlePage }: SaveRegistroFacturasProps) {

  ///store

  const handleCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  //store_gastos
  const clearSelectedItemsGasto = useGastos(s => s.clearSelectedItemsGasto)
  //hooks
  const {
    form, errors, handleSubmit,
    onSave, navigate, reset,
    ingresoInventarioResp, isLoadingIngresoInventario,
    //ordenCompraResp, isLoadingOrdenCompra,
    BodegaRes, isLoadinBodega,
    ubicacionesResp, isLoadingUbicacion,
    proveedorResp, isLoadingProveedor,
    TipoComprobantePaging, isLoadingTipoComprobante,
    formaPagoProveedorResp, isLoadingFormaPagoProveedor,

  } = useRegistroFacturas()


  //useState
  const [optionTipoFactura, setOptionTipoFactura] = useState(-1)
  const [tabTableSelected, setTabTableSelected] = useState(1)
  const [plazoPago, setPlazoPago] = useState('')
  const [facturaXml, setFacturaXml] = useState<any | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  ///
  const handleProductoGastoChange = useCallback((_event: any, value: any) => {
    setTabTableSelected(value)

  }, [])

  ///operattion
  const handleIngresoInventario = (codigo: string) => {
    console.log('codigo', codigo)
    if (!codigo) return
    const result = ingresoInventarioResp?.data?.data.find(item => item.codigo === codigo)
    if (!result) return

    const bode = BodegaRes?.data?.data.find(item => item.codigo === result?.bodega_data?.codigo)
    const ubicacion = ubicacionesResp?.data?.data.find(item => item.codigo === result?.ubicacion_data?.codigo)
    const fecha_creacion = result?.fecha_creacion!
    const proveedor = proveedorResp?.data?.data.find(item => item.codigo === result?.orden_compra_data?.proveedor)
    const forma_pago = formaPagoProveedorResp?.data?.data.find(item => item.codigo === result?.orden_compra_data?.forma_pago)
    const plazo_pago = result?.orden_compra_data?.plazo_pago
    setPlazoPago(plazo_pago!)

    form.setValue('bodega', bode?.codigo!)
    form.setValue('ubicacion', ubicacion?.codigo!)
    form.setValue('fecha_ingreso_bodega', fecha_creacion!)
    form.setValue('proveedor', proveedor?.codigo!)
    form.setValue('forma_pago', forma_pago?.codigo!)
    form.setValue('concepto', result?.orden_compra_data?.concepto!)

    if (result?.productos) {
      const aux: MaterialTransferido[] = result?.productos?.map(element => {
        const cantidaRecibida = Number(element.cantidad_recibida || 0)
        const precioCompra = Number(element.precio_compra || 0)
        const descuento = Number(element.descuento || 0)
        const subTotalDescuento = cantidaRecibida * precioCompra - descuento
        const ivaProducto = subTotalDescuento * (Number(element.iva_porcentaje || 0))
        const totalProducto = subTotalDescuento + ivaProducto
        return {
          ...element,
          cantidad: cantidaRecibida,
          precio_total: cantidaRecibida * precioCompra,
          subtotal_descuento: subTotalDescuento.toFixed(2),
          iva_producto: ivaProducto.toFixed(2),
          total_producto: totalProducto.toFixed(2),
        }
      })
      //console.log('llego nuevos', aux)
      handleCopiarLista(aux)
    }
  }



  //liempieza
  useEffect(() => {
    if (optionTipoFactura === -1) {
      reset({ subtotal_sin_iva: '', iva: '', total_compra: '', descuento: '' })
      form.setValue('subtotal_sin_iva', '')
      form.setValue('iva', '')
      form.setValue('total_compra', '')
      setPlazoPago("")
      clearSelectedItems()
      clearSelectedItemsGasto()
      setFacturaXml(null)
    }
  }, [optionTipoFactura])



  // Funciones de validación simuladas
  const validarProveedor = (ruc: string,/*  razonSocial: string */): boolean => {
    const proveedor = proveedorResp?.data.data.find(item => item.identificacion === ruc);
    if (!proveedor) return false
    form.setValue('proveedor', proveedor.codigo!)
    return true;
  };

  const validarTipoComprobante = (codigo: string) => {
    const tipoComprobante = TipoComprobantePaging?.data.data.find(item => item.codigo_sri === codigo)

    if (!tipoComprobante) return false
    form.setValue('tipo_comprobante', tipoComprobante.codigo)
    return true

    //const tiposValidos = ["01", "02", "03"]; // códigos de comprobantes válidos

  };

  const validarFormaPago = (codigo: string) => {
    const formaPagoProveedor = formaPagoProveedorResp?.data?.data?.find(item => item.codigo_sri === codigo)
    if (!formaPagoProveedor) return false
    form.setValue('forma_pago', formaPagoProveedor.codigo)
    return true
    //const formasValidas = ["19", "01", "15"]; // códigos válidos

  };

  const handleFacturaParseada = (facturaObj: any) => {

    const fechaOriginal = facturaObj.FechaEmision
    const [dd, mm, yyyy] = fechaOriginal.split("/")
    const fechaIso = `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
    form.setValue('fecha_emision', fechaIso);
    form.setValue('numero_autorizacion', facturaObj.NumeroAutorizacion);


  };
  const fechaEmision = form.watch('fecha_emision')

  const parsePlazoPago = (plazo: string) => {
    const regex = /(\d+)\s*(dia|días|mes|meses|año|años)/i;
    const match = plazo.match(regex);

    if (!match) return null
    const cantidad = Number(match[1])
    const unidad = match[2].toLowerCase();

    if (unidad.startsWith("dia")) return { cantidad, unidad: "dias" }
    if (unidad.startsWith("mes")) return { cantidad, unidad: "meses" }
    if (unidad.startsWith("año")) return { cantidad, unidad: "años" }

    return null;
  }


  const formatDateISO = (date: Date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };


  useEffect(() => {
    if (!fechaEmision || !plazoPago) return;

    const parsed = parsePlazoPago(plazoPago);
    if (!parsed) return;

    // FechaEmision ahora está en formato ISO: yyyy-MM-dd
    const [yyyy, mm, dd] = fechaEmision.split("-").map(Number);
    const fechaBase = new Date(yyyy, mm - 1, dd);

    switch (parsed.unidad) {
      case "dias":
        fechaBase.setDate(fechaBase.getDate() + parsed.cantidad);
        break;
      case "meses":
        fechaBase.setMonth(fechaBase.getMonth() + parsed.cantidad);
        break;
      case "años":
        fechaBase.setFullYear(fechaBase.getFullYear() + parsed.cantidad);
        break;
    }

    form.setValue("fecha_vencimiento", formatDateISO(fechaBase));
    //setPlazoPago("")
  }, [fechaEmision, plazoPago]);




  if (isLoadingIngresoInventario || isLoadinBodega || isLoadingUbicacion) return <LoaderComponent />

  return (
    <>
      <Grid container alignItems={"center"} justifyContent={"space-between"} spacing={2}>
        <Grid item>
          <Typography variant="h5">{titlePage}</Typography>
        </Grid>
        <Grid item >
          <Grid container spacing={1} justifyContent={'flex-end'}>
            <Grid item>
              <SingleButton
                label="Volver"
                variant="outlined"
                onClick={() => {
                  navigate(`${ROUTER_PATHS.contabilidad.registroFacturaNav}`)
                }}
                startIcon={<ChevronLeftIcon />}
                color={'inherit'}
              />
            </Grid>

            <Grid item>
              <SingleButton
                label="Guardar"
                variant="outlined"
                startIcon={< FileDownloadDoneIcon />}
                onClick={handleSubmit(onSave,
                  () => {
                    //toast.console.error();
                    toast.error("Todo los campos son obligatorios")
                  }
                )}
                color={'success'}
              />
            </Grid>

          </Grid>

        </Grid>

      </Grid>

      {/*cuerpo*/}
      <FormProvider {...form}>

        <Grid container alignItems="center" spacing={2} py={3} >

          <Grid item>
            <Typography variant="h6">
              {'Escoja el Tipo de Registro'}
            </Typography>
          </Grid>

          <Grid item >
            <Grid container spacing={2} alignItems="center" sx={{ ml: 3 }}>
              <Grid item>
                {(optionTipoFactura === 0 || optionTipoFactura === -1) && (
                  <SampleCheckbox
                    label="Orden de compra"
                    name="contiene_orden_compra"
                    control={form.control}
                    defaultValue={false}
                    sizeCheck="medium"
                    onChangeValue={e => {

                      e ? setOptionTipoFactura(0) : setOptionTipoFactura(-1)
                      setTabTableSelected(1)
                    }}
                  />
                )}

              </Grid>
              <Grid item>
                {(optionTipoFactura === 1 || optionTipoFactura === -1) && (
                  <SampleCheckbox
                    label="Gastos"
                    name="es_gasto"
                    control={form.control}
                    defaultValue={false}
                    sizeCheck="medium"
                    onChangeValue={e => {

                      e ? setOptionTipoFactura(1) : setOptionTipoFactura(-1)
                      setTabTableSelected(2)

                    }}
                  />
                )}

              </Grid>
              <Grid item>
                {(optionTipoFactura === 2 || optionTipoFactura === -1) && (
                  <SampleCheckbox
                    label="Combinados"
                    name="es_combinado"
                    control={form.control}
                    defaultValue={false}
                    sizeCheck="medium"
                    onChangeValue={e => {

                      e ? setOptionTipoFactura(2) : setOptionTipoFactura(-1)
                      setTabTableSelected(1)
                    }}
                  />
                )}

              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container alignItems="center" spacing={2} py={3} >
          {/*   FORMULARIOS */}
          {optionTipoFactura === -1 ? null :
            <>
              {optionTipoFactura !== 1 && (
                <>

                  <TabTextLabel text="- Información de Compra" mt={0} pt={0} pl={2} pb={0} />

                  <CustomAutocomplete<OrdenesCompra>
                    label="orden de compra"
                    name="orden_compra"
                    options={ingresoInventarioResp?.data?.data as any || []}
                    isLoadingData={isLoadingIngresoInventario}
                    valueKey={"nomenclatura"}
                    actualValueKey={'codigo'}
                    defaultValue={form.getValues().orden_compra || ''}
                    control={form.control}
                    error={errors.orden_compra}
                    helperText={errors.orden_compra?.message}
                    size={gridSizeMdLg6}
                    onChangeValue={data => {

                      form.reset({
                        ...form.getValues(),
                        bodega: '',
                        ubicacion: '',
                        proveedor: '',
                        forma_pago: '',
                        concepto: '',
                        numero_autorizacion: ''
                      })
                      // Limpiar estados independientes y productos/gastos
                      clearSelectedItems();
                      clearSelectedItemsGasto();
                      setPlazoPago('');
                      setFacturaXml(null);
                      if (fileInputRef.current) fileInputRef.current.value = ''
                      // Solo cargar datos si hay orden seleccionada
                      if (data) {
                        handleIngresoInventario(data);
                      }
                    }}
                  />

                  <SampleDatePicker
                    label="Fecha Ingreso a Bodega"
                    name="fecha_ingreso_bodega"
                    textFieldKey="fecha_ingreso_bodega"
                    control={form.control}
                    error={errors.fecha_ingreso_bodega}
                    helperText={errors.fecha_ingreso_bodega?.message}
                    defaultValue={new Date().toISOString().split("T")[0]}
                    size={gridSizeMdLg6}
                  />

                  <CustomAutocomplete<BODEGAS>
                    label="Bodega"
                    name="bodega"
                    options={BodegaRes?.data.data || []}
                    isLoadingData={isLoadinBodega}
                    valueKey={'nombre'}
                    actualValueKey="codigo"
                    defaultValue={form.getValues().bodega || ''}
                    control={form.control}
                    error={errors.bodega}
                    helperText={errors.bodega?.message}
                    size={gridSizeMdLg6}
                  />
                  <CustomAutocomplete
                    label="Ubicacion"
                    name="ubicacion"
                    options={ubicacionesResp?.data.data || []}
                    isLoadingData={isLoadingUbicacion}
                    valueKey={'nombre'}
                    actualValueKey="codigo"
                    defaultValue={form.getValues().ubicacion || ''}
                    control={form.control}
                    error={errors.ubicacion}
                    helperText={errors.ubicacion?.message}
                    size={gridSizeMdLg6}
                  />
                </>
              )}


              <TabTextLabel text="* Información Proveedor" mt={3} pt={0} pl={2} pb={0} />
              <Grid item {...gridSize} container spacing={3}>
                <CustomAutocomplete<PROVEEDOR>
                  label="Proveedor"
                  name="proveedor"
                  options={proveedorResp?.data.data || []}
                  isLoadingData={isLoadingProveedor}
                  valueKey={'razon_social'}
                  actualValueKey="codigo"
                  defaultValue={form.getValues().proveedor || ''}
                  control={form.control}
                  error={errors.proveedor}
                  helperText={errors.proveedor?.message}
                  size={gridSizeMdLg6}
                />
                <CustomAutocomplete<TipoComprobante>
                  label="Tipo de Comprobante"
                  name="tipo_comprobante"
                  options={TipoComprobantePaging?.data.data || []}
                  isLoadingData={isLoadingTipoComprobante}
                  valueKey={"nombre"}
                  actualValueKey={'codigo'}
                  defaultValue={form.getValues().tipo_comprobante || ''}
                  control={form.control}
                  error={errors.tipo_comprobante}
                  helperText={errors.tipo_comprobante?.message}
                  size={gridSizeMdLg6}
                />


                <CustomTextField
                  label="Concepto de compra"
                  name="concepto"
                  control={form.control}
                  defaultValue={form.getValues().concepto || ""}
                  error={errors.concepto}
                  helperText={errors.concepto?.message}
                  size={gridSizeMdLg6}
                />

                <CustomAutocomplete
                  label="Forma de Pago"
                  name="forma_pago"
                  options={formaPagoProveedorResp?.data.data || []}
                  isLoadingData={isLoadingFormaPagoProveedor}
                  valueKey={'nombre'}
                  actualValueKey={'codigo'}
                  defaultValue={form.getValues().forma_pago || ''}
                  control={form.control}
                  error={errors.forma_pago}
                  helperText={errors.forma_pago?.message}
                  size={gridSizeMdLg6}
                />

                <CustomTextField
                  name="numero_autorizacion"
                  label="Autorización SRI"
                  control={form.control}
                  defaultValue={form.getValues().numero_autorizacion || ''}
                  error={errors.numero_autorizacion}
                  helperText={errors.numero_autorizacion?.message}
                  size={gridSizeMdLg6}
                />

                <SampleDatePicker
                  label="Fecha Emisión de Comprobante"
                  name="fecha_emision"
                  textFieldKey="fecha_emision"
                  defaultValue={new Date().toISOString().split("T")[0]}
                  control={form.control}
                  error={errors.fecha_emision}
                  helperText={errors.fecha_emision?.message}
                  readonly={true}
                  size={gridSizeMdLg6}
                />

                <SampleDatePicker
                  label="Fecha Vencimiento de Documento"
                  name="fecha_vencimiento"
                  textFieldKey="fecha_vencimiento"
                  defaultValue={new Date().toISOString().split("T")[0]}
                  control={form.control}
                  error={errors.fecha_vencimiento}
                  helperText={errors.fecha_vencimiento?.message}
                  size={gridSizeMdLg6}
                />

                <Grid item {...gridSizeMdLg4}>
                  <XmlUploader
                    inputRef={fileInputRef}
                    idInput="sri"
                    buttonText="Seleccionar XML"
                    fileObject={facturaXml}
                    setFileObject={setFacturaXml}
                    onFileParsed={handleFacturaParseada}
                    validateProveedor={validarProveedor}
                    validateTipoComprobante={validarTipoComprobante}
                    validateFormaPago={validarFormaPago}
                    clearForm={() => {
                      form.reset({
                        ...form.getValues(),
                        proveedor: '',
                        tipo_comprobante: "",
                        forma_pago: "",
                        numero_autorizacion: "",
                        //fecha_emision: "",
                        //fecha_vencimiento: ""
                      })
                    }}
                  />
                </Grid>
              </Grid>
              <NestedTabsScene
                tabs={
                  <FormTabsOnly
                    onChange={handleProductoGastoChange}
                    value={tabTableSelected}
                  >
                    {(form.watch("contiene_orden_compra") || form.watch("es_combinado")) && <Tab label="Productos" value={1} {...a11yProps(1)} />}
                    {(form.watch("es_gasto") || form.watch("es_combinado")) && <Tab label="Gastos" value={2} {...a11yProps(2)} />}

                  </FormTabsOnly>
                }
              >
                {optionTipoFactura !== 1 && (
                  <CustomTabPanel index={tabTableSelected} value={1}>
                    <RegistroFacturaOrdenCompra />
                  </CustomTabPanel>
                )}


                <CustomTabPanel index={tabTableSelected} value={2}>
                  {optionTipoFactura !== 0 && (
                    <RegistroFacturaGastos />
                  )}

                </CustomTabPanel>

                <CustomTabPanel index={tabTableSelected} value={3}>

                </CustomTabPanel>
              </NestedTabsScene>
              {/*  valores factura */}
              <ValoresFactura
                optionTipoFactura={optionTipoFactura}
              />

            </>
          }
        </Grid >

      </FormProvider>
    </>
  )
}